/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `ME` - Microempresa * `EPP` - Empresa de Pequeno Porte * `OUTROS` - Outros
 */
export enum PorteEnum {

    ME = 'ME',

    EPP = 'EPP',

    OUTROS = 'OUTROS'
}

